<template>
  <div></div>
</template>

<script>
import axios from 'axios';
import {ebus} from "@/vendor/ebus";
import {getErrorDetails} from "@/util/globalErrorHandler";

//key mathias: CQKztWzbE6b5uBiEVpPa
const API_KEY = 'CQKztWzbE6b5uBiEVpPa';

export default {
  name: "GeopositionTool",
  created() {
    ebus.$on('getGeoposition', (params) => {
      this.getGeoposition(params.address, params.cbAddress);
    });
  },
  methods: {
    replaceDashesWithSpaces(str) {
      return str.replace(/-/g, ' ');
    },

    getGeoposition(address, cbAddress) {
      console.log('getGeoposition for address: ', JSON.stringify(address, null, 2));
      let street = '';
      let plz = ''
      let city = '';
      try {
        street = this.replaceDashesWithSpaces(address.street);
        plz = this.replaceDashesWithSpaces(address.plz);
        city = this.replaceDashesWithSpaces(address.city);
      } catch (error) {
        ebus.$emit('toast', 'Invalid delivery area address');
      }
      let search = `${street}, ${plz} ${city}`;
      let urlEncoded = encodeURIComponent(search);
      let endpoint = 'https://api.maptiler.com/geocoding/' + urlEncoded + '.json';
      // let endpoint = `https://api.maptiler.com/geocoding/${street}, ${plz} ${city}.json`;
      // let endpoint = `https://api.maptiler.com/geocoding/${street} ${plz} ${city}.json`;
      // let endpoint = `https://api.maptiler.com/geocoding/${street};${plz};${city}.json`;
      console.log('Geoposition API call to endpoint ' + endpoint);
      axios
        .get(endpoint, {
          params: {
            limit: 1,
            types: 'address',
            language: 'de',
            key: API_KEY,
            country: 'de',
          }
        })
        .then((apiReply) => {
          if (apiReply && apiReply.data) {
            console.log('getGeoposition API reply received: ' + JSON.stringify(apiReply.data, null, 2));

            //check relevance
            let hasReply = false;
            try {
              if (Array.isArray(apiReply.data)) {
                for (let entry of apiReply.data) {
                  if (this.xxxx(entry, cbAddress)) {
                    hasReply = true;
                    break;
                  }
                }
                if (!hasReply) {
                  this.reply(cbAddress);
                }
              } else {
                if (this.xxxx(apiReply.data, cbAddress)) {
                  hasReply = true;
                }
              }
            } catch (e) {
              let eMsg = 'error parsing geoposition feature: ' + e.message + ' for endpoint ' + endpoint;
              console.log(eMsg);
              ebus.$emit('throwError', getErrorDetails(e))
            }
            console.log('geoposition hasReply=' + hasReply);
            if (!hasReply) {
              this.reply(cbAddress);
            }
          }
        })
        .catch((err) => {
          ebus.$emit('toast', 'GeopositionTool API error');
          // error callback
          console.log('Catched: No response for get request received; Error: ', err);
        });
    },

    xxxx(entry, cbAddress) {
      //test maptiler address2coordinate: https://www.maptiler.com/cloud/geocoding/?_gl=1*1hyqlzi*_ga*ODk2NTg4MDA5LjE3NDIyODg4MjU.*_ga_K4SXYBF4HT*MTc0MjI4ODgyNS4xLjEuMTc0MjI4ODg5OC4wLjAuMA..
      //test maptiler coordinate2address: https://docs.maptiler.com/sdk-js/examples/geocoding-reverse-json/
      try {
        if (entry.query.length > 1) {
          let feature = entry.features[0];
          console.log('geoposition feature relevance: ' + feature.relevance);
          let c = feature.geometry.coordinates;
          let lan = c[1];
          let lng = c[0];
          console.log('geoposition coordinates lan=' + lan + ' lng=' + lng);
          if (feature.relevance > 0.88) {
            this.reply(cbAddress, lan, lng);
            return true;
          }
        }
      } catch (e) {

      }
      return false;
    },

    reply(cbAddress, lat, lng) {
      let r = {
        ok: !!(lat && lng)
      }
      if (r.ok) {
        r.geoPosition = {
          lat: lat,
          lng: lng
        }
      }
      console.log('geoposition final result: ' + JSON.stringify(r));
      ebus.$emit(cbAddress, r);
    },

  },
}
</script>

<style scoped>

</style>
